export function assertNever(req: never) {
  throw new Error(`Not implemented: ${req}`);
}

export function assertNonEmptyString(value: unknown): asserts value is string {
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(`Expected non-empty string, got ${value}`);
  }
}
export function assertNotNull<T>(value: T): asserts value is NonNullable<T> {
  if (value === null || value === undefined) {
    throw new Error(`Expected non-null, got ${value}`);
  }
}

export function assertOk(value: unknown, message?: string | Error): asserts value {
  if (!value) {
    if (message instanceof Error) {
      throw message;
    }

    const defaultMessage = `Assertion failed: the expression evaluated to a falsy value`;
    throw new Error(message || defaultMessage);
  }
}
